import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'df-funnel-manage-onboarding-flow-banner',
  templateUrl: './funnel-manage-onboarding-flow-banner.component.html',
  styleUrls: ['./funnel-manage-onboarding-flow-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FunnelManageOnboardingFlowBannerComponent {
  @Output() buttonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
}
